module.exports = __webpack_public_path__ + "static/fonts/BMJUA_otf.otf?7592a087";